import { SubmitHandler, useForm } from "react-hook-form";
import axiosInstance from "services/axiosInstance";
import * as S from "./styled";
//Components
import ActionButton from "../../../Button/ActionButton";
import LayoutWithList from "../../../LayoutModal/WithList";
import Loading from "../../../Loading";
//hooks
import { useEffect } from "react";
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from "../../../../hooks/useLoading";
//Interfaces
import { Inputs } from "Interfaces/IAntiGlare";
import { ICreate } from "Interfaces/ICreate";
export default function Update({
  isOpenModal: isOpenModalBraind,
  setModalClose,
  refreshFrames,
  selectedUrlId,
  setToastData,
  setToastOpen
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();

  const fetchData = async () => {
    startLoading();
    try {

      const response = await axiosInstance.get(
        `treatment/${selectedUrlId}`
      );

      const addressData = response.data;
      for (const key in addressData) {
        setValue(key as keyof Inputs, addressData[key]);
      }

    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalBraind && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalBraind, selectedUrlId]);

  const toUpperCaseStrings = (obj: Record<string, any>) => {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key,
        typeof value === 'string' ? value.toUpperCase() : value,
      ])
    );
  };

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = toUpperCaseStrings(data);
      const response = await apiRequest(
        `treatment/${selectedUrlId}`,
        "PUT",
        payload
      );
      const status = response.status;
      if (status === 200) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        setModalClose();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  if (isOpenModalBraind) {
    return (
      <LayoutWithList
        title="Atualizar Antirreflexo"
        subTitle="Atualize as informações do antirreflexo em sua base de dados."
        setModalClose={setModalClose}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <S.Container>
            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Antirreflexo
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o antirreflexo"
                  type="text"
                  {...register("treatment", { required: true })}
                />
                {errors.treatment && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.ContentButton>
                <ActionButton
                  name="Atualizar"
                  onClick={handleFormSubmit(onSubmit)}
                />
              </S.ContentButton>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutWithList>
    );
  }
  return null;
}
